import axios from "axios";
import moment from "moment";
import { currentDate } from "../../util/utilz";
const token = localStorage.getItem("user_id");
const patient_id = localStorage.getItem("patient_id");
const organization_id = localStorage.getItem("org_id");
// const id = localStorage.getItem("id");
let pharmacyInstance = axios.create({
  baseURL: `http://3.113.123.43:5000`,
});

export const getPharmacyDashboardEffect = () => {
  console.log("pharmacy-effect");
  const token = localStorage.getItem("user_id");
  return pharmacyInstance.request({
    url: "/user/pharmacydashboard",
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};

export const getPatientHealthRecordsEffect = () => {
  return pharmacyInstance.request({
    url: "/healthRecord/allList?pagination_required=true&pageNo=1&pagesize=10",
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};
export const GetTabletsEffect = (formData) => {
  const token = localStorage.getItem("user_id");
  return pharmacyInstance.request({
    url: `/tablet/organization`,
    params: {
      organization_id: formData?.OrgId,
      pageNo: formData,
      pagesize: 100,
    },
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};
export const TabletListEffect = (formData) => {
  const token = localStorage.getItem("user_id");
  console.log("formDataformDataformData", formData);
  return pharmacyInstance.request({
    url: `/tablet/organization`,
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    params: {
      organization_id: formData?.organization_id,
      pagesize: 10,
      pageNo: formData?.page,
      pagination_required: formData?.pagination_required
        ? formData?.pagination_required
        : true,
    },
  });
};

export const NewTabletEffect = (formData) => {
  console.log("formData", formData);
  const token = localStorage.getItem("user_id");
  return pharmacyInstance.request({
    url: `/tablet/add`,
    method: "POST",
    data: formData,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};
export const GetTabletEffect = (page) => {
  const token = localStorage.getItem("user_id");
  return pharmacyInstance.request({
    url: "/tablet/list",
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    params: {
      pagesize: 10,
      pageNO: page,
      pagination_required: true,
    },
  });
};
export const UpdateTabletEffect = (formData) => {
  console.log("formData", formData);
  const token = localStorage.getItem("user_id");
  return pharmacyInstance.request({
    url: `/tablet/update/${formData?.id}`,
    method: "PUT",
    data: formData?.formData,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};
export const DeleteTabletEffect = (formData) => {
  console.log("formData", formData);
  const token = localStorage.getItem("user_id");
  return pharmacyInstance.request({
    url: `/tablet/delete/${formData}`,
    method: "DELETE",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};
export const TabletByOrgEffect = (formData) => {
  const token = localStorage.getItem("user_id");

  return pharmacyInstance.request({
    url: `/tablet/organization?organization_id=${formData?.orgId}&pageNo=${formData?.pageNo}&pageSize=${formData?.pageSize}&pagination_required=${formData?.pagination_required}`,
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};
export const TabletCategoryListEffect = (formData) => {
  console.log("formData-TabletCategoryListEffect", formData);
  const token = localStorage.getItem("user_id");
  return pharmacyInstance.request({
    url: `/medicinecategorie/getAllCategorybyorginations?organization_id=${formData?.orgId}&pagination_required=${formData?.pagination}&pageSize=${formData?.pageSize}&pageNo=${formData?.pageNo}`,

    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};
export const AddTabletCategoryEffect = (formData) => {
  console.log("formData-AddTabletCategoryEffect", formData);
  const token = localStorage.getItem("user_id");
  return pharmacyInstance.request({
    url: "/medicinecategorie/insertCategories",
    data: formData,
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};
export const EditTabletCategoryEffect = (formData) => {
  console.log("formData-EditTabletCategoryEffect", formData);
  const token = localStorage.getItem("user_id");
  return pharmacyInstance.request({
    url: `medicinecategorie/updateCategory/${formData?.id}`,
    data: formData,
    method: "PUT",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};
export const DeleteTabletCategoryEffect = (formData) => {
  console.log("formData-DeleteTabletCategoryEffect", formData);
  const token = localStorage.getItem("user_id");
  return pharmacyInstance.request({
    url: `/medicinecategorie/deleteCategory/${formData}`,
    method: "DELETE",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};
export const ProductTypeEffect = () => {
  const token = localStorage.getItem("user_id");
  return pharmacyInstance.request({
    url: "producttype/list",
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};
export const ProductUnitEffect = () => {
  const token = localStorage.getItem("user_id");
  return pharmacyInstance.request({
    url: "/productunit/list",
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};
export const supplierListEffect = (formData) => {
  console.log("formData-TabletCategoryListEffect", formData);
  const token = localStorage.getItem("user_id");
  return pharmacyInstance.request({
    url: `/supplier/supplierbyorganization?pagination_required=${formData?.pagination}&pageSize=${formData?.pageSize}&pageNo=${formData?.pageNo}`,
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};
export const addSupplierEffect = (formData) => {
  console.log("formData-AddTabletCategoryEffect", formData);
  const token = localStorage.getItem("user_id");
  return pharmacyInstance.request({
    url: "/supplier/add",
    data: formData,
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};
export const editSupplierEffect = (formData) => {
  console.log("formData-EditTabletCategoryEffect", formData);
  const token = localStorage.getItem("user_id");
  return pharmacyInstance.request({
    url: `/supplier/update/${formData?.id}`,
    data: formData?.formData,
    method: "PUT",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};
export const deleteSupplierEffect = (formData) => {
  console.log("formData-DeleteTabletCategoryEffect", formData);
  const token = localStorage.getItem("user_id");
  return pharmacyInstance.request({
    url: `/supplier/delete/${formData}`,
    method: "DELETE",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};
export const PharmacyProfileEffect = (formData) => {
  console.log("formData-DeleteTabletCategoryEffect", formData);
  const token = localStorage.getItem("user_id");
  return pharmacyInstance.request({
    url: `/pharmacy/details?pharmacy_id=${formData}`,
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};
export const EditPharmacyProfileEffect = (formData) => {
  console.log("formData-DeleteTabletCategoryEffect", formData);
  const token = localStorage.getItem("user_id");
  return pharmacyInstance.request({
    url: `/pharmacy/update/${formData?.id}`,
    data: formData?.formData,
    method: "PUT",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};
export const ChangePasswordEffect = (formData) => {
  console.log("formData-DeleteTabletCategoryEffect", formData);
  const token = localStorage.getItem("user_id");
  return pharmacyInstance.request({
    url: "/user/changepassword",
    data: formData,
    method: "PUT",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};
export const expiryStockEffect = (formData) => {
  const token = localStorage.getItem("user_id");
  return pharmacyInstance.request({
    url: "/store/getExpiryDate",
    method: "GET",
    params: formData,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "text/plain",
    },
  });
};

export const stockAdjustmentListEffect = (formData) => {
  console.log("formData-TabletCategoryListEffect", formData);
  const token = localStorage.getItem("user_id");
  return pharmacyInstance.request({
    url: `/store/storeListOrganization?pagination_required=${formData?.pagination}&pageNo=${formData?.pageNo}&pagesize=${formData?.pageSize}`,
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};
export const addStockAdjustmentEffect = (formData) => {
  console.log("formData-addStockAdjustmentEffect", formData);
  const token = localStorage.getItem("user_id");
  return pharmacyInstance.request({
    url: "/store/insert",
    data: formData,
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};
export const editStockAdjustmentEffect = (formData) => {
  console.log(
    "formData-editStockAdjustmentEffect",
    formData?.StoresInfo?.insert_details
  );
  const token = localStorage.getItem("user_id");
  return pharmacyInstance.request({
    url: `/store/update/${formData?.id}`,
    data: formData?.StoresInfo?.insert_details[0],
    method: "PUT",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};
export const deleteStockAdjustmentEffect = (formData) => {
  console.log("formData-DeleteTabletCategoryEffect", formData);
  const token = localStorage.getItem("user_id");
  return pharmacyInstance.request({
    url: `/store/delete/${formData}`,
    method: "DELETE",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};

export const purchaseListEffect = (formData) => {
  const token = localStorage.getItem("user_id");
  return pharmacyInstance.request({
    url: `/purchase/getAllPurchase?organization_id=${formData.orgId}&pagination_required=${formData.pagination}&pageSize=10&pageNo=${formData.page}`,
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};
export const addPurchaseEffect = (formData) => {
  console.log("formData-AddTabletCategoryEffect", formData);
  const token = localStorage.getItem("user_id");
  return pharmacyInstance.request({
    url: "/purchase/insert",
    data: formData,
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};
export const editPurchaseEffect = (formData) => {
  console.log("formData-EditTabletCategoryEffect", formData);
  const token = localStorage.getItem("user_id");
  return pharmacyInstance.request({
    url: `/purchase/update/${formData?.id}`,
    data: formData?.data,
    method: "PUT",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};
export const deletePurchaseEffect = (formData) => {
  console.log("formData-DeleteTabletCategoryEffect", formData);
  const token = localStorage.getItem("user_id");
  return pharmacyInstance.request({
    url: `/purchase/deletePurchase/${formData}`,
    method: "DELETE",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};

export const purchaseRequestListEffect = (formData) => {
  const token = localStorage.getItem("user_id");
  return pharmacyInstance.request({
    url: `/purchaseRequest/organization?organization_id=${formData?.organization_id}&pageNo=${formData?.pageNo}&pagesize=${formData?.pageSize}&pagination_required=${formData?.pagination_required}`,
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};
export const addPurchaseRequestEffect = (formData) => {
  console.log(formData);
  const token = localStorage.getItem("user_id");
  return pharmacyInstance.request({
    url: "/purchaseRequest/add",
    data: formData,
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};
export const editPurchaseRequestEffect = (formData) => {
  const token = localStorage.getItem("user_id");
  return pharmacyInstance.request({
    url: `/purchaseRequest/update/${formData?.id}`,
    data: formData?.data,
    method: "PUT",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};
export const deletePurchaseRequestEffect = (formData) => {
  console.log("formData-DeleteTabletCategoryEffect", formData);
  const token = localStorage.getItem("user_id");
  return pharmacyInstance.request({
    url: `/purchaseRequest/delete/${formData}`,
    method: "DELETE",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};

export const purchaseReturnListEffect = (formData) => {
  console.log("formData-TabletCategoryListEffect", formData);
  const token = localStorage.getItem("user_id");
  return pharmacyInstance.request({
    url: `/purchasereturn/organization?pagination_required=${formData?.pagination_required}&organization_id=${formData?.organization_id}&pageNo=${formData?.pageNo}&pagesize=${formData?.pagesize}`,
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};
export const addPurchaseReturnEffect = (formData) => {
  console.log("formData-AddTabletCategoryEffect", formData);
  const token = localStorage.getItem("user_id");
  return pharmacyInstance.request({
    url: "/purchasereturn/add",
    data: formData,
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};
export const editPurchaseReturnEffect = (formData) => {
  console.log("formData-EditTabletCategoryEffect", formData);
  const token = localStorage.getItem("user_id");
  return pharmacyInstance.request({
    url: `/purchasereturn/update/${formData?.id}`,
    data: formData?.editFormData,
    method: "PUT",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};
export const deletePurchaseReturnEffect = (formData) => {
  console.log("formData-DeleteTabletCategoryEffect", formData);
  const token = localStorage.getItem("user_id");
  return pharmacyInstance.request({
    url: `/purchasereturn/delete/${formData}`,
    method: "DELETE",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};
export const getTabletIdEffect = (formData) => {
  console.log("formData-DeleteTabletCategoryEffect", formData);
  const CurrentDate = moment().format("YYYY-MM-DD");
  const token = localStorage.getItem("user_id");
  return pharmacyInstance.request({
    url: `/store/getTabletById?pageNo=${1}&pagesize=${5}&pagination_required=${
      formData?.pagination_required
    }&current_date=${CurrentDate}&name=${
      formData?.name ? formData?.name : null
    }`,
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};

export const addSalesEffect = (formData) => {
  console.log("formData-AddTabletCategoryEffect", formData);
  const token = localStorage.getItem("user_id");
  return pharmacyInstance.request({
    url: "/sales/add",
    data: formData,
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};

export const getSalesEffect = (formData) => {
  console.log("formData-AddTabletCategoryEffect", formData);
  const token = localStorage.getItem("user_id");
  return pharmacyInstance.request({
    url: `/sales/saleslist?pageNo=${formData?.page}&pagesize=10&pagination_required=${formData?.pagination}&organization_id=${formData?.orgId}`,
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};

export const getSalesDetailsEffect = (formData) => {
  console.log("formData-AddTabletCategoryEffect", formData);
  const token = localStorage.getItem("user_id");
  return pharmacyInstance.request({
    url: `/sales/getsales?sales_id=${formData}`,
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};

export const editSalesEffect = (formData) => {
  console.log("formData-EditTabletCategoryEffect edit", formData);
  const token = localStorage.getItem("user_id");
  return pharmacyInstance.request({
    url: `/sales/update/${formData?.id}`,
    data: formData?.formData,
    method: "PUT",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};
export const departmentListEffect = (formData) => {
  console.log("formData-TabletCategoryListEffect", formData);
  const token = localStorage.getItem("user_id");
  return pharmacyInstance.request({
    url: "/departments/getlist/",
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};
export const addDepartmentEffect = (formData) => {
  console.log("formData-AddTabletCategoryEffect", formData);
  const token = localStorage.getItem("user_id");
  return pharmacyInstance.request({
    url: "/departments/insert",
    data: formData,
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};
export const editDepartmentEffect = (formData) => {
  console.log("formData-EditTabletCategoryEffect", formData);
  const token = localStorage.getItem("user_id");
  return pharmacyInstance.request({
    url: `/departments/update/${formData?.id}`,
    data: formData?.datas,
    method: "PUT",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};
export const deleteDepartmentEffect = (formData) => {
  console.log("formData-DeleteTabletCategoryEffect", formData);
  const token = localStorage.getItem("user_id");
  return pharmacyInstance.request({
    url: `/departments/delete/${formData}`,
    method: "DELETE",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};
export const pharmacyListEffect = (formData) => {
  console.log("formData-TabletCategoryListEffect", formData);
  const token = localStorage.getItem("user_id");
  return pharmacyInstance.request({
    url: `/pharmacy/list/organization?pagination_required=${formData?.pagination}&pageNo=${formData?.pageNo}&pagesize=${formData?.pageSize}&organization_id=${formData?.orgId}`,
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};
export const itemTransferListEffect = (formData) => {
  console.log("formData-TabletCategoryListEffect", formData);
  const token = localStorage.getItem("user_id");
  return pharmacyInstance.request({
    url: `itemtransfer/getbyorganization?pagination_required=${formData?.pagination}&pagesize=${formData?.pageSize}&pageNo=${formData?.pageNo}`,
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};
export const addItemTransferEffect = (formData) => {
  console.log("formData-AddTabletCategoryEffect", formData);
  const token = localStorage.getItem("user_id");
  return pharmacyInstance.request({
    url: "/itemtransfer/insert",
    data: formData,
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};
export const editItemTransferEffect = (formData) => {
  console.log("formData-EditTabletCategoryEffect", formData);
  const token = localStorage.getItem("user_id");
  return pharmacyInstance.request({
    url: `/itemtransfer/update/${formData?.id}`,
    data: formData?.formData,
    method: "PUT",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};
export const deleteItemTransferEffect = (formData) => {
  console.log("formData-DeleteTabletCategoryEffect", formData);
  const token = localStorage.getItem("user_id");
  return pharmacyInstance.request({
    url: `itemtransfer/delete/${formData}`,
    method: "DELETE",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};
export const addBulkMedicineEffect = (formData) => {
  console.log("formData-addBulkMedicineEffect", formData);
  const token = localStorage.getItem("user_id");
  return pharmacyInstance.request({
    url: "/tablet/bulkInsertTablets",
    data: formData,
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "multipart/form-data",
    },
  });
};

export const deleteSalesEffect = (formData) => {
  console.log("formData-DeleteTabletCategoryEffect", formData);
  const token = localStorage.getItem("user_id");
  return pharmacyInstance.request({
    url: `/sales/delete/${formData}`,
    method: "DELETE",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};

export const addSalesPaymentEffect = (formData) => {
  console.log("formData-DeleteTabletCategoryEffect", formData);
  const token = localStorage.getItem("user_id");
  return pharmacyInstance.request({
    url: `/pharmacybilling/add`,
    method: "POST",
    data: formData,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};

export const updateSalesPaymentEffect = (formData) => {
  console.log("formData-EditTabletCategoryEffect", formData);
  const token = localStorage.getItem("user_id");
  return pharmacyInstance.request({
    url: `/pharmacybilling/update/${formData?.id}`,
    data: formData?.datas,
    method: "PUT",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};

export const getSalesDueEffect = (formData) => {
  console.log("formData-DeleteTabletCategoryEffect", formData);
  const token = localStorage.getItem("user_id");
  return pharmacyInstance.request({
    url: `/pharmacybilling/getdue?patient_id=${formData.patient_id}`,
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      organization_id: organization_id,
    },
  });
};

export const salesCancelUndoEffect = (formData) => {
  console.log("formData-DeleteTabletCategoryEffect", formData);
  const token = localStorage.getItem("user_id");
  return pharmacyInstance.request({
    url: `/sales/cancel?sales_id=${formData.sales_id}&type=${formData.type}&reason=${formData.reason}`,
    method: "PUT",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};

export const patientSalesDueEffect = (formData) => {
  console.log("formData-DeleteTabletCategoryEffect", formData);
  const token = localStorage.getItem("user_id");
  return pharmacyInstance.request({
    url: `/sales/patientdues?pagination_required=${formData?.pagination}&pageNo=${formData?.pageNo}&pagesize=${formData?.pageSize}`,
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      organization_id: organization_id,
    },
  });
};

export const dueByPatientEffect = (formData) => {
  console.log("formData-DeleteTabletCategoryEffect", formData);
  const token = localStorage.getItem("user_id");
  return pharmacyInstance.request({
    url: `/sales/getDues?patient_id=${formData?.patient_id}&pagination_required=${formData?.pagination}&pagesize=${formData?.pageSize}&pageNo=${formData?.pageNo}`,
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};

export const addSalesReturnEffect = (formData) => {
  console.log("formData-DeleteTabletCategoryEffect", formData);
  const token = localStorage.getItem("user_id");
  return pharmacyInstance.request({
    url: `/salesreturn/insert`,
    method: "POST",
    data: formData,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};

export const getSalesReturnListEffect = (formData) => {
  console.log("formData-DeleteTabletCategoryEffect", formData);
  const token = localStorage.getItem("user_id");
  return pharmacyInstance.request({
    url: `/salesreturn/salesListorganization?pagination_required=${
      formData?.pagination
    }&pageNo=${formData?.pageNo}&pagesize=${
      formData?.pageSize ? formData?.pageSize : 10
    }`,
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};

export const updateSalesReturnEffect = (formData) => {
  console.log("formData-DeleteTabletCategoryEffect", formData);
  const token = localStorage.getItem("user_id");
  return pharmacyInstance.request({
    url: `/salesreturn/update/${formData.id}`,
    method: "PUT",
    data: formData?.data,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};

export const getSalesListByPatientEffect = (formData) => {
  console.log("formData-DeleteTabletCategoryEffect", formData);
  const token = localStorage.getItem("user_id");
  return pharmacyInstance.request({
    url: `/sales/getpatientsales?patient_id=${
      formData?.patient_id
    }&pagination_required=${formData?.pagination}&pageNo=${
      formData?.pageNo
    }&pagesize=${formData?.pageSize ? formData?.pageSize : 10}`,
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};
export const addBulkPurchaseEffect = (formData) => {
  console.log("formData-addBulkMedicineEffect", formData);
  const token = localStorage.getItem("user_id");
  return pharmacyInstance.request({
    url: "/purchase/bulkinsertpurchase",
    data: formData,
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "multipart/form-data",
    },
  });
};
export const bulkMedicineCategoryEffect = (formData) => {
  console.log("formData-addBulkMedicineEffect", formData);
  const token = localStorage.getItem("user_id");
  return pharmacyInstance.request({
    url: "/medicinecategorie/bulkInsertcategories",
    data: formData,
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "multipart/form-data",
    },
  });
};
export const getGstListEffect = (formData) => {
  console.log("formData-DeleteTabletCategoryEffect", formData);
  const token = localStorage.getItem("user_id");
  return pharmacyInstance.request({
    url: "/gst/list",
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};

export const getPharmacyReportListEffect = (formData) => {
  console.log("formData-DeleteTabletCategoryEffect", formData);
  const token = localStorage.getItem("user_id");
  return pharmacyInstance.request({
    url: `/pharmacybilling/getReports?organization_id=${organization_id}&report_type=daily&to_date=${
      formData.to_date
    }&from_date=${formData.from_date}&pagination_required=${
      formData?.pagination
    }&pageNo=${formData?.pageNo}&pagesize=${
      formData?.pageSize ? formData?.pageSize : 10
    }`,
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};

export const getAvabileStockListEffect = (formData) => {
  console.log("formData-DeleteTabletCategoryEffect", formData);
  const token = localStorage.getItem("user_id");
  return pharmacyInstance.request({
    url: `/store/availablestock?organization_id=${organization_id}&stock=${formData.stock}&current_date=${currentDate}`,
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};
